module.exports = __webpack_public_path__ + "static/media/icon-mine.20e8878b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/medias/icon-mine.svg
// module id = 180
// module chunks = 0